import React from "react";
import _ from "lodash";
import { Modal } from "react-bootstrap";

const ModalBuyPlotTxnSuccess = ({ showModal, itemDetail, closeModal }) => {
  return (
    <>
      <Modal
        show={showModal}
        dialogClassName="modal-dialog modal-dialog-centered"
        contentClassName={"customPopup processingModal modal-xsm"}
      >
        <button onClick={closeModal} className="close"></button>

        <div className="content">
          <div className="modal-caption text-center">
            <h2 className="title title-sm fw--700">Processing</h2>
            <div className="wait muteClr">
              Please wait, your request is processing.
            </div>
          </div>
          <button
            className="custom-btn accent-bg lg w-100"
            onClick={closeModal}
          >
            Hide
          </button>
        </div>
      </Modal>
    </>
  );
};
export default ModalBuyPlotTxnSuccess;
